import { useState } from 'react';
import { useIdToken } from 'react-firebase-hooks/auth';

import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import { auth } from '@/services/firebase.service';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import SettingsLoadingPage from '@/shared-components/loaders/components/SettingsLoadingPage';
import SettingsHeading from '@/shared-components/text/components/SettingsHeading';
import Text from '@/shared-components/text/components/Text';

import ChangePasswordForm from './components/ChangePasswordForm';

import './index.css';

export default function LogIn() {
  const { state } = useStateHandler();
  const t = useTranslations('common.user_settings.login');
  const [changePassword, setChangePassword] = useState(false);
  const [user, loading] = useIdToken(auth);

  if(loading) {
    return (
      <SettingsLoadingPage page={t('loading_page')}/>
    );
  } else {
    return (
      <>
        <SettingsHeading text={t('heading')}/>
        <div className="settings-login__container">
          {
            user.providerData[0].providerId === "google.com" ?
              <>
                <Text
                  className="settings-login__text font-size-medium"
                  style={{ marginBottom: "10px" }}
                  paragraph
                  justify>
                  {t('google_linked_message')}
                </Text>

                <PublicFormInput 
                  className="settings-login__read-only" 
                  placeholder={t('placeholders.email')}
                  element="user_email" 
                  readOnly={true} 
                  fillWith={state.user_session.user_email.toLowerCase()}
                />

                <PublicFormInput 
                  className="settings-login__read-only" 
                  placeholder={t('placeholders.username')}
                  element="user_username" 
                  readOnly={true} 
                  fillWith={state.user_session.user_username} 
                  margin
                />
              </>
              :
              <>
                <PublicFormInput 
                  className="settings-login__read-only" 
                  placeholder={t('placeholders.email')}
                  element="user_email" 
                  readOnly={true} 
                  fillWith={state.user_session.user_email.toLowerCase()}
                />
    
                <PublicFormInput 
                  className="settings-login__read-only" 
                  placeholder={t('placeholders.username')}
                  element="user_username" 
                  readOnly={true} 
                  fillWith={state.user_session.user_username} 
                  margin
                />

                <div className="settings-login__password-container">
                  <PublicFormInput
                    placeholder={t('placeholders.password')}
                    element="user_password" 
                    type="password" 
                    readOnly={true} 
                    fillWith="*************"
                  />
                
                  {!changePassword && (
                    <Text
                      className="settings-login__change-password-text element-non-selectable font-size-medium"
                      onClick={()=>setChangePassword(true)}>
                      {t('actions.change_password')}
                    </Text>
                  )}
                </div>
                
                {changePassword && <ChangePasswordForm/>}
              </>
          }
        </div>
      </>
    );
  }
}
